import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../../dashboard/rfq-cache.service';
import { AbstractControl, FormBuilder,FormArray, FormControl, FormGroup, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import { aboutDataType, AutoCompleteDataType, AutoCompleteSupplierProduct, Currency, quoteAttachmentType, quoteDeclineReasonType,incoterms, offeredQuality, portData,supplierBranchData, Vessel  } from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from "uuid";
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from '../purchase-order.service';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
// import * as html2pdf from 'html2pdf.js';



interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}

interface Countries {
  name: string;
  code: string;
  dialcode: string;
  currency: string;
  flag:string;
}

interface Location {
  locationId: number;     
  locationName: string;   
  code: string;        
}

interface Incoterm {
  incotermId: number;      
  incotermCode: string;   
  userId: number;     
  locationDetails: Location[]; 
}

@Component({
  selector: 'app-purchase-order-details',
  templateUrl: './purchase-order-details.component.html',
  styleUrls: ['./purchase-order-details.component.css']
})

export class PurchaseOrderDetailsComponent implements OnInit{
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;
  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!: number;
  isSaved: boolean = false;
  currentTab: string = 'preview';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs:any[]=[]
  currentIndex = 0;

  headerResponse: any;
  portAgencyAndFreightAndBillingResponse:any;


  showAcceptOrder:boolean = false;
  showRejectOrder:boolean = false;
  showOrderConfirmed:boolean = false;

  orderConfirmationNumber: string = '';
  deliveryDate!: Date;
  shippingDate!: Date;

  buyerId!:number;

  rejectionReasons: { id: number; reason: string }[] = [];
  rejectionReason!: number;
  rejectionMessage: string = '';

  showFreightDetails: boolean = false;
  freightValues:any[]=[]

  toggleFreightDetails() {
    this.showFreightDetails = !this.showFreightDetails;
  }


//   tabs: any[] = [
//     {
//       index: 0,
//       label: 'LINE ITEMS',
//       icon: "directions_boat",
//       route: 'line-items',
//     },
//     {
//       index: 1,
//       label: 'HEADER DETAILS',
//       icon: "looks",
//       route: 'header',
//     },
//     {
//       index: 2,
//       label: 'PAYMENT TERMS',
//       icon: "location_searching",
//       route: 'payment-terms',
//     },{
//       index: 3,
//       label: 'PREVIEW',
//       icon: "location_searching",
//       route: 'preview',
//     }
//   ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  secondFormGroup!: UntypedFormGroup;
  declineFormGroup!: UntypedFormGroup;
  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData:any;
  showDeclineConfirmationDialogue:boolean=false
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;
  
  showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;
  showHazardousDeclaration: boolean = false;

  displayedColumns = ['position', 'partNumber', 'supplierPartNumber', 'itemDescription',
     'buyerComment', 'supplierComment', 'customsCode', 'uom', 'quantity',  'supplierUom', 'supplierQuantity', 
     'unitCost', 'requestedUnitCost','discount', 'totalCost', 'requestedTotalCost','leadTime','attachments','delete'
  ];

  groupHeadersColumns = [
  'checkboxGroup',
  'positionGroup',
  'partNumberGroup',
  'supplierPartNumberGroup',
  'itemDescriptionGroup',
  'buyerCommentGroup',
  'supplierCommentGroup',
  'customsCodeGroup',
  'attachmentsGroup',
  'uomQuantityGroup',
  'supplierUomQuantityGroup',
  'unitCostGroup',
  'discountGroup',
  'totalCostGroup',
  'leadTimeGroup',
  'deleteGroup'
];

  lineItemAttachmentTypeData:quoteAttachmentType[]=[]
  delineReasonData:quoteDeclineReasonType[]=[]

  selectedLineItemIndex!:number | null

  declineReason!:number | null
  otherReason:string=''

  freightDescription:string=''
  freightType:string='amount'
  freightValue!:number |null
  addedAdditionalCost:any[]=[]

  selectedAttachmentType!:number|null
  hazardousDeclaration!:number|null
  newfileuploaded:boolean=false;
  uploadedAttachmentsArray: any[] = []; 
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB
  

  currentdate=new Date()
  taxStatusData:any[]=[]
  tableWidth = '100%';
  dynamicColumns = [
    // { key: 'buyerComment', name: 'Buyer Comment', visible: false },
    // { key: 'supplierComment', name: 'Supplier Comment', visible: false },
    // { key: 'customsCode', name: 'Customs Code', visible: false },
    // { key: 'quantity', name: 'Requested Quantity', visible: false },
    // { key: 'uom', name: 'Requested UOM', visible: false },
    // { key: 'unitCost', name: 'Unit Cost', visible: false },
    // { key: 'discount', name: 'Discount', visible: false },
    // { key: 'totalCost', name: 'Total Cost', visible: false },
    // { key: 'leadTime', name: 'Lead Time', visible: false },
    // { key: 'supplierUom', name: 'Supplier UOM', visible: false },
    // { key: 'supplierQuantity', name: 'Supplier Quantity', visible: false },
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
    // { key: 'delete', name: 'Delete', visible: false },
  ];


  firstFormGroup!: UntypedFormGroup;
 

  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;
  isForm7Expand: boolean = true;
  isForm8Expand: boolean = true;

  isForm9Expand: boolean = true;
  isForm10Expand: boolean = true;
  isForm11Expand: boolean = true;
  isForm12Expand: boolean = true;

  lastId!: number;
  headerAttachmentUrl:any;
  headerAttachmentSection:boolean=false;
  paymentTermsAndConditionsSection:boolean=false;
  buyerAttachmentsSection:boolean=false;
  paymentTermsAndConditions:any;
  paymentTermsAndConditionAttachmentUrl:any;
  buyerAttachmentUrl:string[]=[];
  incoterms:incoterms[]=[]
  offeredQualityData:offeredQuality[]=[]
  headerAttachmentType:quoteAttachmentType[]=[]
  lineItemAttachmentType:quoteAttachmentType[]=[]

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  boundGetCountryAutoComplete!: (pageMeta: Page) => Observable<any>;

  searchKeyParams: string = '';
  delAttachmentArr:number[] = [];

  countryControl: FormControl = new FormControl();
  // countries: Countries[] = [];
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList:any[]=[]

  paymentFormGroup!: UntypedFormGroup;
  buyerFormGroup!: UntypedFormGroup;

  supplierId!: any;
  incotermLocations: string = '';
  buyerLogo: string = '';
  supplierLogo: string = '';
  incotermsCode: number | null = null;

  buyerStreet:any;
  buyerCity:any;
  buyerZipCode:any;
  buyerStateCode:any;
  buyerCountry:any;


  selectedTermsConditionIndex!:number | null
  previewDoc:any[]=[]
  uploadedAdditionalAttachmentsArray: any[] = []; 

  status!:string;

   filterFieldCountryNameDisplayFn(_country: AutoCompleteDataType) {
    return _country ? `${_country.name}` : undefined;
  }
  showColumn(col:{ key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    // this.tableWidth = 'max-content';
    // this.cdr.detectChanges();
    this.table.recalculate(); 
  }

  showToggleColumns(col:any){
    col.visible = !col.visible;
    this.table.recalculate(); 
  }

  getColumn(key: string) {
    return this.dynamicColumns.find(c => c.key === key);
  }

  boundGetSupplierProductAutoComplete!: (pageMeta: Page) => Observable<any>;


  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService:RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService
  ) {

   
    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([])
    });
  }

  async ngOnInit() {

    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

      this.boundGetSupplierProductAutoComplete =
      this.getSupplierProductFilterKeyDataObservable.bind(this);
  
    this.getTaxDetails()

    this.secondFormGroup = this._formBuilder.group({

      quoteLineItemHeaderId:[null],
      quoteLineItemListPriceSubtotal:[null],
      quoteLineItemDiscount:[null],
      quoteLineItemSubtotal :[null],
      quoteLineItemGeneralDiscountType :['percentage'],
      quoteLineItemGeneralDiscountValue:[null],
      quoteLineItemFreightTotal:[null],
      quoteLineItemFreight:[null],
      quoteLineItemTotal :[null],
      supplierCurrency: [null],
      quoteLineItemApplicableTaxProfile: [null],
      quoteLineItemTaxAmount: [null],
    });

    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    this.firstFormGroup = this._formBuilder.group({
        // Purchase Order Details
        purchaseOrderId: [''],
        purchaseOrderRefNumber: [''],
        purchaseOrderDate: [''],
        rfqRefNumber: [''],
        rfqDate: [''],
        quoteRefNumber: [''],
        quotationDate: [''],
        expectedDeliveryDate: [''],

        // Buyer Company Details
        buyerName: [''],
        buyerEmail: [''],
        buyerPhone: [''],
        buyerFax: [''],
        buyerAddress: [''],

        // Buyer Details
        buyerContactPerson: [''],
        buyerContactEmail: [''],
        buyerContactPhone: [''],
        buyerContactFax: [''],
        buyerContactAddress: [''],
        buyerOrganizationLogo: [''],

        // Supplier Details
        supplierName: [''],
        supplierContactName: [''],
        supplierEmail: [''],
        supplierPhone: [''],
        supplierFax: [''],
        supplierCompanyEmail: [''],
        supplierOrganizationLogo: [''],
        supplierCompanyName: [''],

        // Vessel Details
        vesselName: [''],
        vesselIMONumber: [''],
        vesselType: [''],
        vesselClass: [''],

        // Port Details
        portName: [''],
        portCode: [''],
        vesselETA: [''],
        vesselETD: [''],
        requestedDeliveryDate: [''],
        
        incoterms: [''],
        incotermLocations: ['']
    });


    this.paymentFormGroup = this._formBuilder.group({
        // Buyer Payment Terms
        billingAddress: [''],
        applicableTaxProfile: [''],
        buyersPaymentTerms: [''],
        buyerTermsAndConditions: [''],

        // Port Agent Details
        portAgencyName: [''],
        portAgentName: [''],
        portAgentPhoneNumber: [''],
        portAgentContact: [''],
        portAgentPhoneFax: [''],
        portAgentEmail: [''],
        portAgentAddress: [''],

        // Terms and Conditions (file upload + text)
        termsAndConditions: [''],
        attachments: [null],

        // Freight Forwarder Details
        freightCompanyName: [''],
        freightPIC: [''],
        freightJobTitle: [''],
        freightEmail: [''],
        freightPhone: [''],
        freightFax: [''],
        freightAddress: [''],
        freightPackaging: [''],
        freightTransportMode: ['']
     });

    this.lineItemAttachmentTypeData = await this.quoteService.fetchAllQuteAttachmentType('QuoteLineItemAttachmentType');
    
    this.delineReasonData = await this.quoteService.fetchAllDeclineReason();

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId'] !=' ') {

        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']
        this.purchaseOrderId = params['purchaseOrderId']
        this.status = params['status']

        this.getQuoteDraftData()
        let param1 = {
          purchaseOrderId:this.purchaseOrderId,
          section:"header"
        }
        const result1 = await this.purchaseOrderService.fetchPurchaseOrder(param1);
        const data = result1[0];
        this.headerResponse = data;
        console.log("headerResponse",this.headerResponse);
        this.supplierId = data.supplierId;
        this.buyerLogo = data.buyerOrganizationLogo || '';
        this.supplierLogo = data.supplierOrganizationLogo || '';
        this.incotermLocations = data.incotermLocations || '';
        this.incotermsCode = data.incoterms || null;
        console.log({data});
        this.buyerId= data.buyerId;
        this.firstFormGroup.patchValue({
        // Purchase Order Details
        purchaseOrderId: data.purchaseOrderId || '',
        purchaseOrderRefNumber: data.purchaseOrderRefNumber || '',
        purchaseOrderDate: data.purchaseOrderDate || '',
        rfqRefNumber: data.rfqRefNumber || '',
        rfqDate: data.rfqDate || '',
        quoteRefNumber: data.quoteRefNumber || '',
        quotationDate: data.quotationDate || '',
        // expectedDeliveryDate: data.onTimeDeliveryOrderBy 
        //     ? new Date(new Date(data.onTimeDeliveryOrderBy).setDate(
        //         new Date(data.onTimeDeliveryOrderBy).getDate() + (Number(data.quotedDeliveryInDays) || 0)
        //     )).toISOString().split('T')[0] 
        //     : '',
        expectedDeliveryDate: data.expectedDeliveryDate || '',
        // Buyer Company Details
        buyerName: data.buyerCompanyName || '',
        buyerEmail: data.companyEmailId || '',
        buyerPhone: data.companyPhoneNumber || '',
        buyerFax: data.companyFax || '',
        buyerAddress: data.companyAddress || '',

        // Buyer Details
        buyerContactPerson: data.buyerContactPerson || '',
        buyerContactEmail: data.buyerEmail || '',
        buyerContactPhone: data.buyerPhone || '',
        buyerContactFax: data.buyerFax || '',
        buyerContactAddress: data.buyerAddress || '',
        buyerOrganizationLogo: data.buyerOrganizationLogo || '',


        // Supplier Details
        supplierName: data.supplierName || '',
        supplierContactName: data.supplierContactPerson || data.supplierFullName || '',
        supplierEmail: data.supplierEmail || '',
        supplierPhone: data.supplierPhone || '',
        supplierFax: data.supplierFax || '',
        supplierCompanyEmail: data.supplierCompanyEmail || data.supplierEmail ||'',
        supplierOrganizationLogo: data.supplierOrganizationLogo || '',
        supplierCompanyName: data.supplierCompanyName || '',

        // Vessel Details
        vesselName: data.vesselName || '',
        vesselIMONumber: data.vesselImoNumber || '',
        vesselType: data.vesselType || '',
        vesselClass: data.class || '',

        // Port Details
        portName: data.portName || '',
        portCode: data.portCode || '',
        vesselETA: data.vesselEta || '',
        vesselETD: data.vesselEtd || '',
        requestedDeliveryDate: data.requestedDeliveryDate || '',

        incoterms: data.incoterms || '',
        incotermLocations: data.incotermLocations || '',
        });

        console.log("incotermLoations")

        let param2={
            purchaseOrderId:this.purchaseOrderId,
            section: "paymentTerms"
          }
          const result2= await this.purchaseOrderService.fetchPurchaseOrder(param2);
          console.log({result2});
          const response = result2[0];
          this.portAgencyAndFreightAndBillingResponse=result2[0];
          // Update form values
          this.paymentFormGroup.patchValue({
            billingAddress: response.invoiceAddressType==2 ? response.billingAddress:'',
            applicableTaxProfile: response.applicableTaxProfile,
            buyersPaymentTerms: response.buyersPaymentTerms,
            buyerTermsAndConditions: response.termsAndConditions, 
            portAgencyName: response.portAgencyName,
            portAgentName: response.portAgentName,
            portAgentPhoneNumber: response.portAgentPhoneNumber,
            portAgentContact: response.portAgentContact,
            portAgentPhoneFax: response.portAgentPhoneFax,
            portAgentEmail: response.emailId,  
            portAgentAddress: response.address,
            termsAndConditions: response.termsAndConditions,
            attachment: response.paymentTermsAttachments,
            freightCompanyName: response.freightCompanyName || '',
            freightPIC: response.freightPIC || '',
            freightJobTitle: response.freightJobTitle || '',
            freightEmail: response.freightEmail || '',
            freightPhone: response.freightPhone || '',
            freightFax: response.freightFax || '',
            freightAddress: response.freightAddress || '',
            freightPackaging: response.freightPackaging || '',
            freightTransportMode: response.freightTransportMode || ''
            // freightPackaging: response.freightPackaging
            //   ? response.freightPackaging.map((p: any) => p.packagingType).join(', ')
            //   : '',
            
            // freightTransportMode: response.freightTransportMode
            //   ? response.freightTransportMode.map((m: any) => m.modeOfTransport).join(', ')
            //   : ''
          });
          this.uploadedAdditionalAttachmentsArray = response.paymentTermsAttachments

          // await this.getLastAcceptedOrderId()
      }
    })

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);
    this.fetchRfqDetails()
  }

  // Normalize numeric values to 3 decimals consistently
  private round3(value: any): number {
    const n = Number(value ?? 0);
    if (!isFinite(n)) return 0;
    return Math.round((n + Number.EPSILON) * 1000) / 1000;
  }


  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand
    }
    else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand
    }
    else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand
    }
    else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand
    }
    else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand
    }
    else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand
    }
    else if (section == 'form7') {
      this.isForm7Expand = !this.isForm7Expand
    }
    else if (section == 'form8') {
      this.isForm8Expand = !this.isForm8Expand
    }
    else if (section == 'form9') {
      this.isForm9Expand = !this.isForm9Expand
    }
    else if (section == 'form10') {
      this.isForm10Expand = !this.isForm10Expand
    }
    else if (section == 'form11') {
      this.isForm11Expand = !this.isForm11Expand
    }
    else if(section == 'form12') {
      this.isForm12Expand = !this.isForm12Expand
    }
   
  }

  async save(isDraft?:boolean) {

    
    console.log("INSIDE SAVE");
    this.fullLoaderService.showLoader();

    if(isDraft){
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }
    
    const params = {
        section: 'preview',
        purchaseOrderStatus: isDraft? 14:3,
        purchaseOrderTabId:4,
        quoteId: this.quoteId,
        userId: Number(this.cookieService.get('userId')),
        purchaseOrderId:this.purchaseOrderId,
        termsConditionsAttachment: this.paymentFormGroup.get('attachments')?.value,
        rfqId: this.rfqId
      };

      const result = await this.purchaseOrderService.updatePurchaseOrder(params);
      this.fullLoaderService.hideLoader()
      if(!isDraft){
        setTimeout(() => {

          this.router.navigate([
            "dashboard", "supplier"
          ]);

        }, 3000); // 3000 milliseconds = 3 seconds
      }
      
  }

  isValidFreight(): boolean {
    const freightField = this.secondFormGroup.get('quoteLineItemFreight');
    
    // Check if freight details are provided
    if (!freightField?.value || freightField?.value.length === 0) {
      return false; // Return false if freight details are not provided
    }

    return true; // Return true if freight details are valid
  }

  async back() {

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['rfqId'] != '' && params['quoteId'] != '' ) {

        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']


        this.router.navigate([
          "dashboard", "quote", "create", 'header'
        ],
          {
            queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
          }
        );

    }})
    

  }
  closeLineItems(){
    this.router.navigate([
      "operations", "all-documents"
    ]
    );
  }
  async next() {

    // if (this.isSaved) {
      
    //   this.activatedRoute.queryParams.subscribe(async params => {


    //     if (params['rfqId'] != '' && params['quoteId'] != '' ) {
  
    //       this.rfqId = params['rfqId']
    //       this.quoteId = params['quoteId']
  
  
    //       this.router.navigate([
    //         "dashboard", "quote", "create", 'payment-terms'
    //       ],
    //         {
    //           queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
    //         }
    //       );
  
    //   }})


    // }

    if (this.isSaved) {

      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['rfqId'] != '' && params['quoteId'] != '') {

          this.rfqId = params['rfqId']
          const quoteId = this.quoteId

          this.router.navigate([
            "dashboard", "quote", "create", 'header'
          ],
            {
              queryParams: { rfqId: this.rfqId, quoteId: quoteId }
      
            }
          );

        }

      })
    }
    // else{
    //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    // }
  }

  // async close() {}

  calculateRowValues(index: number): void {
    
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row)
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });
    
    this.calculateCostSummary()

  }


  calculateCostSummary(){
    
      let subTotalCost = 0;
      let totalDiscount = 0;
      let totalUnitCost = 0;
      let totalCost = 0;
      let totalFreightAmount = 0;

      let taxPercentage = 0;
      let taxAmount = 0;
    
      const lineItemTable = this.lineItemtableForm.value;

      const row = lineItemTable.rows

      row.forEach((item: any) => {
        if (item.isActive === 1){
        
        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount  || 0;
        const discountedUnitPrice =  item.discountedUnitPrice || 0;
       
  
        const rowTotalCost = this.round3(discountedUnitPrice * quantity);
        const rowDiscount = this.round3(discount * quantity);
        const rowUnitCost = this.round3(unitCost * quantity);

        subTotalCost = this.round3(subTotalCost + rowTotalCost);
        totalDiscount = this.round3(totalDiscount + rowDiscount);
        totalUnitCost = this.round3(totalUnitCost + rowUnitCost);
        totalCost = this.round3(totalCost + rowTotalCost);
        }
        
    });

   
    
    if(this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value != null ){
       
      const type = this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value

      const genDiscount = parseFloat(this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value || '0');

      if(type == 'percentage' ){
        const decrement = this.round3((genDiscount / 100) * totalCost);
        totalCost = this.round3(totalCost - decrement);
      }
      else{
        totalCost = this.round3(totalCost - genDiscount);
      }
    }
    // if(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value != null){

    //   const type = this.secondFormGroup.get('quoteLineItemFreightTotal')?.value

    //   const freight = parseFloat(this.secondFormGroup.get('quoteLineItemFreight')?.value || '0');

    //   if(type == 'percentage' ){
    //     totalCost += (freight / 100) * totalCost;
    //   }
    //   else{
    //     totalCost = totalCost + freight;
    //   }
    //   }
    if(this.secondFormGroup.get('quoteLineItemFreight')?.value != null){

      console.log("hi")
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value

      if(freight.length > 0){

        freight.forEach((item: { freightValue: string; freightType: string; }) => {
          
          
          const freightValue = this.round3(parseFloat(item.freightValue));
          if (item.freightType === 'percentage') {
            const increment = this.round3((freightValue / 100) * totalCost);
            totalCost = this.round3(totalCost + increment); // Apply percentage freight value
            totalFreightAmount = this.round3(totalFreightAmount + increment);

          } else if (item.freightType === 'amount') {
            totalCost = this.round3(totalCost + freightValue); // Add flat freight amount
            totalFreightAmount = this.round3(totalFreightAmount + freightValue); 
          }
        });
  
      }
    
      }

  
    if(this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value != null ){

      const selectedTaxId = this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value;
      console.log("selectedTaxId",selectedTaxId);
      console.log("taxStatusData",this.taxStatusData);
      const selectedTaxProfile = this.taxStatusData.find(tax => tax.taxId === Number(selectedTaxId));
      console.log("selectedTaxProfile",selectedTaxProfile);


      if (selectedTaxProfile && selectedTaxProfile.taxPercentage) {
        taxPercentage = parseFloat(selectedTaxProfile.taxPercentage);
      }

       
      // Check if valid tax percentage
      if (!isNaN(taxPercentage) && taxPercentage > 0) {
        taxAmount = (subTotalCost * taxPercentage) / 100;
        totalCost = totalCost + taxAmount;
      }
    }

    console.log(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value,totalFreightAmount,'totalFreightAmount')
    
    this.secondFormGroup.get('quoteLineItemTaxAmount')?.setValue(this.round3(taxAmount), { emitEvent: false });

    this.secondFormGroup.get('quoteLineItemFreightTotal')?.setValue(this.round3(totalFreightAmount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemListPriceSubtotal')?.setValue(this.round3(totalUnitCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemDiscount')?.setValue(this.round3(totalDiscount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemSubtotal')?.setValue(this.round3(subTotalCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemTotal')?.setValue(this.round3(totalCost), { emitEvent: false });

    
    
  }

  calculateTaxAmount(index: number): void {
    
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row)
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });
    
    this.calculateCostSummary()

  }


  populateForm(data: any[]) {
    console.log(data)
    data.forEach(item => {
      this.addRow(item);
    });
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) &&  // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32)                      // space
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {
    
    // const discountedUnitPrice = this.calculateDiscountedUnitPrice(data);
    // const totalCost = this.calculateTotalCost(data, discountedUnitPrice);

    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      partNumber: [data.partNumber || ''],
      supplierPartNumber: [data.supplierPartNumber || ''],
      itemDescription: [data.itemDescription || ''],
      impaId: [data.impaId || 0],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      customsCode: [data.customsCode || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      // supplierQuantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity || 0],
      unitCost: [data.price || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [data.price || 0.00],
      discount: [data.discount || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [data.discountedUnitPrice || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      totalCost: [data.totalCost || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost:[data.totalCost || 0.00],
      isActive: [data.isActive ],
      declineReasonTypeId : [data.declineReasonTypeId || null],
      delineOtherReason:[data.delineOtherReason || ''],
      declineReasonDescription:[data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],

      isNew: [data.isNew || 0],
      isAddedBySupplier: [data.isAddedBySupplier || 0],
      supplierProductId:  [data.supplierProductId || 0],
      addedLineItempartNumber:[data.addedLineItempartNumber || 0]

    });

    console.log(this.lineItemtableForm.get('rows'),'test 1')

    // this.setupRowListeners(row);
    this.rows.push(row); // Add the row to the FormArray

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }


  addNewLineItem(){

    const obj = {
      position: this.dataSource.length+1,
      id: null,
      partNumber: null,
      supplierPartNumber:null,
      itemDescription: null,
      impaId: null,
      buyerComment: null,
      supplierComment: '',
      customsCode: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom:null,
      supplierQuantity:0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive:1,
      isNew: 1,
      isAddedBySupplier: 1,
      supplierProductId: 0,
      addedLineItempartNumber:0
         
    }

    // const obj = {
    //   position: this.dataSource.length + 1,   // Increment position based on the length of dataSource
    //   id: null,
    //   partNumber: null,
    //   supplierPartNumber: null,
    //   itemDescription: null,
    //   impaId: null,
    //   buyerComment: null,
    //   supplierComment: '',
    //   customsCode: '',
    //   attachments: [],
    //   uom: null,
    //   quantity: 0,
    //   supplierUom: null,
    //   supplierQuantity: 0,
    //   price:0,
    //   discount:null,
    //   totalCost: null,
    //   isActive: true,
    //   isNew: true
    // };


    this.addRow(obj)
    this.dataSource = [...this.dataSource, obj];
    // this.dataSource = lineItemData

    console.log(this.lineItemtableForm.get('rows'),'test 2',this.dataSource)
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  get selectedTaxProfile() {
    const taxId = this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value;
    return this.taxStatusData.find(tax => tax.taxId === Number(taxId));
  }

  async prefillRfqLineItems() {
   
    if(this.rfqId){

      this.fullLoaderService.showLoader();

      let params = {rfqId:this.rfqId, supplierId:Number(this.cookieService.get('userId'))}
      
      const data = await this.quoteService.fetchRfqLineItemDetails(params)
      
      if( data &&  data.length > 0){
        
        this.dataSource = []

        const lineItemData = data;
        
        lineItemData.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            partNumber: item.partNumber,
            supplierPartNumber:item.partNo,
            itemDescription: item.itemDescription,
            impaId: item.supplierProductId,
            buyerComment: item.buyerComments,
            supplierComment: '',
            customsCode: '',
            attachments: '',
            uom: item.uom,
            quantity: item.quantity,
            supplierUom:'',
            supplierQuantity:'',
            unitCost: item.unitCost,
            discount: item.discount,
            totalCost: item.price,
            isActive:item.isActive
            
          }

          
  
          this.dataSource.push(obj);


      })

      this.dataSource = [...this.dataSource];

      }

      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader()
  
       
      }


    


  }

  async getLastAcceptedOrderId() {
    try {
      const result = await this.purchaseOrderService.getLastAcceptedOrderId();
      console.log({result})
      const lastId = (result[0]?.lastId ?? 0) + 1;

      const orderConfirmationNumber = `OC-${this.firstFormGroup.get('purchaseOrderRefNumber')?.value}-${lastId
        .toString()
        .padStart(2, "0")}`;

      console.log({
        lastId,
        orderConfirmationNumber,
      });

      this.orderConfirmationNumber = orderConfirmationNumber;
    } catch (error) {
      console.error("Error getting last accepted order id:", error);
      throw error;
    }
  }

  async fetchAllRejectionReason() {
    try {
      const result: any = await this.purchaseOrderService.fetchAllRejectionReason();
      console.log({ result });

      this.rejectionReasons = result.map((r: any) => ({
        id: r.id,
        reason: r.reason
      }));

      console.log("rejectionReasons",this.rejectionReasons);
    } catch (error) {
      console.error("Error getting Rejection Reason:", error);
      throw error;
    }
  }

  goToConfirmedOrderOverview(){
    this.router.navigate([
      "settings", "inbox"
    ]);
  }

  async fetchRfqDetails(){
      this.fullLoaderService.showLoader()
      let paramsData = {rfqId:this.rfqId, supplierId:Number(this.cookieService.get('userId'))}
      const data = await this.quoteService.fetchRfqDetails(paramsData)
      this.headerData = data.rfqData[0]
      setTimeout(() => {
        this.fullLoaderService.hideLoader()
      }, 7000);
  }

  async rfqActions(action:string){
    
    if(action == 'download'){
    
    this.fullLoaderService.showLoader()
    
    let fileName = this.headerData?.rfqRefNumber +'.pdf';
    
    let data = {
      supplierId: Number(this.cookieService.get("userId")),
      rfqId: this.rfqId
    }
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
    }

    else if(action == 'decline'){
      
      this.showDeclineConfirmationDialogue = true

    }

    else if(action == 'acknowledge'){
     
      this.fullLoaderService.showLoader()

      let data = {
        operation:action,
        selectedRfqId : [this.headerData.supplierRfqId]
      }

      await this.SettingsService.rfqOperations(data)
      this.fullLoaderService.hideLoader()
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

    }
    this.fetchRfqDetails()
  }

  async selectMatTabLink(tabItem:any){

    // await this.save();
    // if(this.showNotification)return;

    if (tabItem.route == 'header') {
       this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']
            this.purchaseOrderId = params['purchaseOrderId']

            this.router.navigate([
              "operations", "createOrder", 'header'
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId:this.purchaseOrderId }
        
              }
            );

          }

        })
    }

    else if (tabItem.route == 'payment-terms') {

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']
            this.purchaseOrderId = params['purchaseOrderId']


            this.router.navigate([
              "operations", "createOrder", 'payment-terms'
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId: this.purchaseOrderId }
              }
            );

          }

        })
    }else if (tabItem.route == 'line-items'){

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

            this.rfqId = params['rfqId']
            this.quoteId = params['quoteId']
            this.purchaseOrderId = params['purchaseOrderId']

            this.router.navigate([
              "operations", "createOrder", 'line-items'
            ],
              {
                queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId: this.purchaseOrderId }
              }
            );

          }

        })
    }
  }

  async checkisTabEnabled() {

    // const data2 = await this.quoteService.getQuoteDraftData('tab1', this.quoteId)

    // if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {

    //   this.tabEnabled = true

    // }

  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.router.navigate([
        "operations","supplier-purchase-order-list",
      ]);
      
    }

  }

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
    this.showAcceptOrder = false;
    this.showRejectOrder = false;
    this.showOrderConfirmed = false;
  }

  

  closeAcceptOrderConfirmation(){
    this.showOrderConfirmed = false;
    this.router.navigate(['/operations/supplier-purchase-order-list'], {
        queryParams: {
          selectedStatus: 'Accepted',
          label: 'Order',
        },
      });
  }

  async acceptOrder() {

    const poPayload = this.buildPurchaseOrderPayloadForSupplierAttachment();
    console.log({poPayload});

    const params = {
      orderConfirmationNumber: this.orderConfirmationNumber,
      estimatedDeliveryDate: this.deliveryDate,
      estimatedShippingDate: this.shippingDate,
      purchaseOrderRefNumber: this.firstFormGroup.get('purchaseOrderRefNumber')?.value,
      buyerName: this.firstFormGroup.get('buyerName')?.value,
      rfqRefNumber: this.firstFormGroup.get('rfqRefNumber')?.value,
      supplierName: this.firstFormGroup.get('supplierName')?.value,
      buyerEmail: this.firstFormGroup.get('buyerEmail')?.value,
      supplierEmail: this.firstFormGroup.get('supplierEmail')?.value,
      buyerOrganizationLogo: this.firstFormGroup.get('buyerOrganizationLogo')?.value,
      supplierOrganizationLogo: this.firstFormGroup.get('supplierOrganizationLogo')?.value,
      buyerId: this.buyerId,
      supplierId: Number(this.cookieService.get('userId')),
      rfqId: Number(this.rfqId),
      quotationId: Number(this.quoteId),
      purchaseOrderId: Number(this.purchaseOrderId),
      supplierCompanyName : this.firstFormGroup.get('supplierCompanyName')?.value,
      pdfPayload: poPayload,
    }
    console.log('Order Accepted:', {
      params
    });
    this.showAcceptOrder = false;
    this.fullLoaderService.showLoader();
    await this.purchaseOrderService.sendPurchaseOrderConfirmationAcknowledgement(params);
    await this.downloadPO();
    this.fullLoaderService.hideLoader();
    this.showOrderConfirmed = true;
  }


  async rejectOrder() {

    console.log('Selected Reason ID:', this.rejectionReason);
    console.log('Message:', this.rejectionMessage);

    const selectedReason = this.rejectionReasons.find(
    r => r.id === Number(this.rejectionReason)
      );

    console.log("selectedReason",selectedReason);


    const poPayload = this.buildPurchaseOrderPayloadForSupplierAttachment();
    console.log({poPayload});

    const params = {
      reasonId: this.rejectionReason,
      rejectReason: selectedReason?.reason, 
      rejectionMessage: this.rejectionMessage,
      purchaseOrderRefNumber: this.firstFormGroup.get('purchaseOrderRefNumber')?.value,
      buyerName: this.firstFormGroup.get('buyerName')?.value,
      rfqRefNumber: this.firstFormGroup.get('rfqRefNumber')?.value,
      supplierName: this.firstFormGroup.get('supplierName')?.value,
      buyerEmail: this.firstFormGroup.get('buyerEmail')?.value,
      supplierEmail: this.firstFormGroup.get('supplierEmail')?.value,
      buyerOrganizationLogo: this.firstFormGroup.get('buyerOrganizationLogo')?.value,
      supplierOrganizationLogo: this.firstFormGroup.get('supplierOrganizationLogo')?.value,
      buyerId: this.buyerId,
      supplierId: Number(this.cookieService.get('userId')),
      rfqId: Number(this.rfqId),
      quotationId: Number(this.quoteId),
      purchaseOrderId: Number(this.purchaseOrderId),
      requestedDeliveryDate: this.firstFormGroup.get('requestedDeliveryDate')?.value,
      portName : this.firstFormGroup.get('portName')?.value,
      vesselName : this.firstFormGroup.get('vesselName')?.value,
      supplierCompanyName : this.firstFormGroup.get('supplierCompanyName')?.value,
      pdfPayload: poPayload,
      alternativeSuggested:'No'
    };

    console.log('Order Rejected:', {
      params
    });
    this.showRejectOrder = false;
    this.fullLoaderService.showLoader();
    await this.purchaseOrderService.sendPurchaseOrderRejectionAcknowledgement(params);
    this.fullLoaderService.hideLoader();

    this.router.navigate(['/operations/supplier-purchase-order-list'], {
        queryParams: {
          selectedStatus: 'Rejected',
          label: 'Order',
        },
      });
  }

  

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    // setTimeout(() => {
    //   if (this.table) {
    //     this.table.recalculate();
    //   }
    // }, 100);
  }

  toggleSidebar(value:boolean, section:string,index?:number){

   

    if(section == 'attachment'){
      this.showAddDocumentSection = value
      if(index !== undefined){
        this.selectedLineItemIndex = index
      }
    }
    else if(section == 'cost'){
      this.showAddCostSection = value
    }
    else if(section == 'decline'){

      if(index !== undefined){

        const rows = this.lineItemtableForm.get('rows') as FormArray;

        const selectedRow = rows.at(index);


        if (selectedRow.value.isNew === 1) {

          rows.removeAt(index);

          console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

          this.dataSource.splice(index, 1);

          this.dataSource = [...this.dataSource]; 

          this.snack.open(`New line item removed.`, "OK", { duration: 3000 });

          this.calculateCostSummary()
        } 

        else{
          this.selectedLineItemIndex = index
          this.showDeclineSection = value
        }

        
        
      }
    }
  }

  fileOver(event:any) {
  }
  fileLeave(event:any) {
  }

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try{


      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (this.selectedAttachmentType == undefined || this.selectedAttachmentType == null) {

        this.snack.open('Please select the attachment type.', 'OK', {
          duration: 3000,
        });
        return;

      }

      if (this.selectedAttachmentType == 1 || this.selectedAttachmentType == 4) {
 
       
        if (this.hazardousDeclaration == null || this.hazardousDeclaration == undefined) {

          this.snack.open('Hazardous Declaration can not be empty.', 'OK', {
            duration: 3000,
          });

          return;

        }


      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();
     
      if(this.selectedLineItemIndex!=null){
        
        this.uploadedAttachmentsArray = rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];
      
        if (this.uploadedAttachmentsArray.length > 5) {
        
        throw new Error('Maximum 5 files allowed for a product!');
         }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!')
            }

            let uploadedAttachment:any = {
              lineItemIndex:this.selectedLineItemIndex,
              dataUrl:'',
              name:file.name,
              file:file,
              attachmentType: this.selectedAttachmentType,
              hazardousDeclaration:this.hazardousDeclaration
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true)
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            })

            this.uploadedAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      rows.at(this.selectedLineItemIndex).patchValue({
        attachments: this.uploadedAttachmentsArray
              
      });
      console.log( rows.at(this.selectedLineItemIndex).get('attachments')?.value,this.uploadedAttachmentsArray)

      this.fullLoaderService.hideLoader();
    }
  }catch(error:any){
    this.snack.open(error, 'OK', {
      duration: 1000,
    });
  }
  }

  onDeclineReasonChange(event: MatSelectChange){
    
    const selectedValue = event.value;
    
    if(selectedValue=='7'){
      this.showOtherReason = true
    }
    else{
      this.showOtherReason = false
    }
  }


  onAttachmentTypeChange(event: MatSelectChange){
    
    const selectedValue = event.value;
    
    if(selectedValue == 1 || selectedValue == 4){
      this.showHazardousDeclaration = true
    }
    else{
      this.showHazardousDeclaration = false
    }
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  declineLineItem(){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;
  

    if(this.declineReason ==undefined || this.declineReason ==null ){
      
      this.snack.open('Please select the decline reason.', 'OK', {
        duration: 3000,
      });
      return;
    
  }

      if( this.declineReason == 7 && (this.otherReason == null || this.otherReason == '')){
          
        this.snack.open('Other reason can not be empty.', 'OK', {
          duration: 3000,
        });
        
        return;
      
    }

      const reason = this.delineReasonData.find(item => item.id === this.declineReason);

      const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

      if(this.selectedLineItemIndex!=null){
        

        // const selectedRow = rows.at(this.selectedLineItemIndex);


        // if (selectedRow.value.isNew === 1) {

        //   rows.removeAt(this.selectedLineItemIndex);

        //   console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

        //   this.dataSource.splice(this.selectedLineItemIndex, 1);
        //     // Trigger change detection if you're using MatTable
        //   this.dataSource = [...this.dataSource]; 

        //   this.snack.open(`New line item removed.`, "OK", { duration: 3000 });
        // } 
        // else {

        rows.at(this.selectedLineItemIndex).patchValue({
          isActive: 0,
          declineReasonTypeId : this.declineReason,
          delineOtherReason: this.otherReason,
          declineReasonDescription: reasonDesc,
          attachments:[],
          supplierQuantity:0
  
        });

        this.snack.open(`Line Item Declined, selected line item attachments are removed`, "OK", { duration: 3000 });
      
        }
      // }
      
      
      this.showDeclineSection = false
      this.declineReason = null
      this.otherReason = ''
      this.selectedLineItemIndex = null

      this.calculateCostSummary()
    
  }

  restoreLineitem(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId :null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity:quantityValue || 1

    });

    this.snack.open(`Line Item Restored`, "OK", { duration: 3000 });

    this.calculateCostSummary()

  }

  isDecline(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const isActive = row.get('isActive')?.value;
    
    // Return the value (true or false)
    return isActive === 0; 
  }

  getDeclineReason(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const reason = row.get('declineReasonDescription')?.value || '';
    
    return `Declined - ${reason || 'No reason provided'}`;
   
  }

  isNew(index:number){
    
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    const isNew = row.get('isNew')?.value;
    
    // Return the value (true or false)
    return isNew === 1; 
  }

  saveAdditionalCost(){
   

    if(this.freightDescription =='' || this.freightType =='' || this.freightValue ==null ){
      
      this.snack.open('Please fill the additional cost details.', 'OK', {
        duration: 3000,
      });
      return;
    
     } 
      let params = {
        id:null,
        freightDescription: this.freightDescription,
        freightType: this.freightType,
        freightValue: this.freightValue,
        isActive:1
      }
      console.log('params',params);
      this.addedAdditionalCost.push(params)

      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost)

      console.log(this.addedAdditionalCost)
      console.log(this.secondFormGroup);
      console.log('test',this.secondFormGroup.get('quoteLineItemFreight')?.value);
      this.calculateCostSummary()

      this.showAddCostSection = false
      this.freightDescription = ''
      this.freightType = 'amount'
      this.freightValue = null
    


  }


  async getQuoteDraftData() {

    this.fullLoaderService.showLoader()

    // const data = await this.quoteService.getQuoteDraftData('tab2', Number(this.quoteId))
    let params = {
      purchaseOrderId:this.purchaseOrderId,
      section:"lineItems"
    }
    const data = await this.purchaseOrderService.fetchPurchaseOrder(params);

    console.log({data});

      if (data && data.length > 0 && Object.keys(data[0]).length > 0 && data[0].quotationLineItems.length > 0) {


        if ( data[0].quotationLineItems[0].quoteLineItemDetailsId) {
          this.isSaved = true
        }

        this.secondFormGroup.patchValue({


          quoteLineItemHeaderId: data[0].quoteLineItemHeaderId || '',
          quoteLineItemListPriceSubtotal: this.round3(data[0].lineItemListPriceSubtotal || 0),
          quoteLineItemDiscount: this.round3(data[0].lineItemDiscount || 0),
          quoteLineItemSubtotal: this.round3(data[0].lineItemSubtotal || 0),
          quoteLineItemGeneralDiscountType: data[0].generalDiscountType || 'percentage',
          // DB provides percentage; set percent now, convert to amount after items load
          quoteLineItemGeneralDiscountValue: this.round3(data[0].generalDiscountValue || 0),
          quoteLineItemFreightTotal: this.round3(data[0].lineItemFreightTotal || 0),
          quoteLineItemFreight: Array.isArray(data[0].quoteLineItemFreight) ? data[0].quoteLineItemFreight.map((f: any) => ({...f, freightValue: this.round3(f?.freightValue || 0)})) : [],
          quoteLineItemTotal: this.round3(data[0].lineItemTotal || 0),
          supplierCurrency: data[0].currency,
          quoteLineItemApplicableTaxProfile:data[0].lineItemApplicableTaxProfile || null,
          quoteLineItemTaxAmount: data[0].lineItemTaxAmount || 0
         
        });
        console.log("quoteLineItemApplicableTaxProfile",this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value);
        console.log("lineitmefreight",this.secondFormGroup.get('quoteLineItemFreight')?.value);

        const selectedTaxId = this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value;
        console.log("selectedTaxId",selectedTaxId);
        console.log("taxStatusData",this.taxStatusData);
        const selectedTaxProfile = this.taxStatusData.find(tax => tax.taxId === Number(selectedTaxId));

        console.log("selectedTaxProfile",selectedTaxProfile.applicableTaxProfile);

        // this.secondFormGroup.patchValue({
        //   quoteLineItemApplicableTaxProfile: selectedTaxProfile.applicableTaxProfile
        // })

        this.dataSource = [];

        if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {

          data[0].quotationLineItems.forEach((item: {
            supplierProductId: any;
            isAddedBySupplier: any;
            leadTime: any;
            attachments: any;
            declineReasonTypeId: any;
            declineReasonDescription: any;
            delineOtherReason: any;
            supplierQuantity: any;
            supplierUom: any;
            uom: any;
            customsCode: any;
            buyerComment: any;
            impaId: any;
            supplierPartNumber: any;
            quoteLineItemDetailsId: any;
            isActive: any;
            partNumber: any;itemDescription: any; unitCost: any; discount: any; supplierComment: any;  quantity: any; discountedUnitPrice: any; totalCost: any; 
             }, index: number) => {
            const obj = {
              position: index + 1, // Assign position based on index
              id: item.quoteLineItemDetailsId,
              partNumber: item.partNumber,
              supplierPartNumber: item.supplierPartNumber,
              itemDescription: item.itemDescription,
              impaId: item.impaId,
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              customsCode: item.customsCode,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: this.round3(item.unitCost),
              discount: this.round3(item.discount),
              discountedUnitPrice: this.round3(item.discountedUnitPrice),
              totalCost: this.round3(item.totalCost),
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments:item.attachments,
              leadTime:item.leadTime,
              isNew:0,
              isAddedBySupplier: item.isAddedBySupplier,
              supplierProductId:  item.supplierProductId
              

            };

           

            this.dataSource.push(obj); // Push each object to dataSource

          });

          this.dataSource = [...this.dataSource]; 
          this.populateForm(this.dataSource);
          // Convert general discount percent into absolute amount and set type to 'amount'
          const gdPercent = Number(data[0].generalDiscountValue || 0);
          if (!isNaN(gdPercent)) {
            let baseTotal = 0;
            (data[0].quotationLineItems || []).forEach((li: any) => {
              if (li?.isActive === 1) {
                const qty = Number(li?.supplierQuantity) || 0;
                const unit = Number(li?.unitCost) || 0;
                const disc = Number(li?.discount) || 0;
                const discUnit = li?.discountedUnitPrice != null
                  ? Number(li.discountedUnitPrice)
                  : this.round3(unit * (1 - disc / 100));
                baseTotal = this.round3(baseTotal + this.round3(discUnit * qty));
              }
            });
            const absolute = this.round3((gdPercent / 100) * baseTotal);
            this.secondFormGroup.patchValue({
              quoteLineItemGeneralDiscountType: 'amount',
              quoteLineItemGeneralDiscountValue: absolute,
            }, { emitEvent: false });
          }
          // this.toggleSelectAllLineItem(true)


      
        }


      }

      else {

        this.prefillRfqLineItems()
        this.fetchDefaultCurrency()

      }
      // this.fullLoaderService.hideLoader()

  }


  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

// Function to display the notification with missing fields
showMissingFieldsNotification(missingFields: { section: string, fields: string[] }[]) {
  let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

  // Loop through each section and list its missing fields
  missingFields.forEach(missingField => {
    message += `<strong>${missingField.section}:</strong><br>`; // Add section name
    message += missingField.fields.map(field => `  • ${field}`).join('<br>'); // List missing fields with bullet points
    message += '<br><br>'; // Add extra spacing between sections
  });

  this.notificationMessage = message;
  this.notificationTitle = 'Missing Fields';
  this.notificationType = 'error'; // Change this to 'info' for informational notifications
  this.showNotification = true; // Display the notification
}



  // // Validation logic to check for required fields
  // isValidRequiredFields(): { section: string, fields: string[] }[] {
  //   console.log("isValidRequiredFields called")
  //   const missingFields: { section: string, fields: string[] }[] = [];

  //   // Check for missing fields in Tab1 (Line Items Section)
  //   const lineItemMissingFields: string[] = [];
  //   // const lineItems = this.secondFormGroup.value;
  //   const lineItems = this.lineItemtableForm.value.rows
  //   console.log({lineItems});
  //   if (!lineItems.unitCost || lineItems.unitCost <= 0) {
  //     lineItemMissingFields.push('Unit Cost for line item');
  //   }
  //   if (!lineItems.leadTime || lineItems.leadTime <= 0) {
  //     lineItemMissingFields.push('Lead Time for line item');
  //   }

  //   if (lineItemMissingFields.length > 0) {
  //     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  //   }

  //   // Show notification if there are missing fields
  //   if (missingFields.length > 0) {
  //     this.showMissingFieldsNotification(missingFields);
  //   }

  //   return missingFields;
  // }

  isValidRequiredFields(): { section: string, fields: string[] }[] {
  const missingFields: { section: string, fields: string[] }[] = [];

  // ✅ Check for missing fields in Tab1 (Line Items Section)
  const lineItemMissingFields: string[] = [];
  const lineItems = this.lineItemtableForm.value?.rows || [];

  lineItems.forEach((item: any, index: number) => {
    if (!item.unitCost || item.unitCost <= 0) {
      lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
    }
    if (!item.leadTime || item.leadTime <= 0) {
      lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
    }
  });
  const form = this.secondFormGroup;

  if (!form.get('supplierCurrency')?.value) {
    lineItemMissingFields.push('Preferred Currency');
  }

  if (lineItemMissingFields.length > 0) {
    missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  }

  // Show notification if there are missing fields
  if (missingFields.length > 0) {
    this.showMissingFieldsNotification(missingFields);
  }

  return missingFields;
}


  getLineItemAttachment(){
   
    const rows = this.lineItemtableForm.value.rows
    
    if(this.selectedLineItemIndex!=null){
      const row = rows[this.selectedLineItemIndex];
      const attachment = row.attachments || []
      // Get the value of the 'isActive' field
       return attachment;
    }
    else{
      return []
    }
   
    
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.SettingsService.getAllCurrenciesByFliterKeyValue(
      pageMeta.serachParam,
      pageMeta
    );
  }


  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }


  
  onPartNumberSelected(event: any, index:number) {
    console.log(event,'event')
    
    const selectedItem = event

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    rows.at(index).patchValue({
      partNumber:selectedItem.partNo,
      supplierPartNumber:selectedItem.partNo,
      itemDescription:selectedItem.ItemName,
      impaId:selectedItem.impaId,
      supplierProductId: selectedItem.supplierProductId,
      quantity:1,
      supplierQuantity:1,
      isNew: 1,
      isAddedBySupplier :1
      
    });

  }
  // Category autocomplete section
  filterFieldSupplierProductNameDisplayFn(_supplierProduct: AutoCompleteSupplierProduct) {
    return _supplierProduct ? `${_supplierProduct.partNo}` : undefined;
  }

  getSupplierProductFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    console.log('Search Parameter:', pageMeta.serachParam);
    const response = this.SettingsService.getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierId(
      pageMeta.serachParam,
      Number(this.CookieService.get("userId")),
      pageMeta,

    );
    console.log('Response Category', response);
    return response;
  }


  getPartNumberControl(index: number): FormControl {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index) as FormGroup;
    return row.get('addedLineItempartNumber') as FormControl ;
  }

  async getTaxDetails() {
    this.fullLoaderService.showLoader();
    let data = {
      supplierId: Number(this.cookieService.get('userId')),
    };
    const response = await this.SettingsService.getTaxDetailsBySupplier(data);
    this.taxStatusData = response.rows;
    // this.fullLoaderService.hideLoader();
  }

  async fetchDefaultCurrency(){
    this.fullLoaderService.showLoader();
    const transactionSetupdata = await this.SettingsService.fetchSupplierSetup('TransactionSetup',Number(this.CookieService.get('userId')))
      
      if(transactionSetupdata.length > 0 ){

        this.secondFormGroup.patchValue({
          supplierCurrency: {
            id:transactionSetupdata[0].default_currency,
            currencyName:transactionSetupdata[0].currencyName,
            currencyCode:transactionSetupdata[0].currencyCode,
            currencySymbol:transactionSetupdata[0].currencySymbol
          },
        });
    // this.fullLoaderService.hideLoader();
        
  }
  }

//   async togglePreview(value:boolean,section:string,docs?:any){
//     this.previewSection=value;
//     this.previewDocs = []
//     if(docs){
//       if(section == 'single'){
//          this.previewDocs.push(docs)
//       }
//       else if(section == 'multiple'){
//         this.previewDocs = docs
//       }
//     }
//   }

//   nextSlide() {
//     this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
//   }

//   prevSlide() {
//     this.currentIndex =
//       (this.currentIndex - 1 + this.previewDocs.length) %
//       this.previewDocs.length;
//   }

  nextSlide() {
    this.currentIndex =
      (this.currentIndex + 1) % this.previewDoc.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDoc.length) %
      this.previewDoc.length;
  }

  async togglePreview(value: boolean, section:string ,index?: number) {

     this.currentIndex = 0
     
    
     if(value){
       
      if(section == 'generalAttachment'){
      
        if(value){
  
           this.previewDoc= this.uploadedAdditionalAttachmentsArray;

           console.log("previewDoc",this.previewDoc);
           
          } else {
            this.previewDoc=[]
          } 
      }
       
     }
     else{
         this.previewDoc=[]
     }

     this.previewSection = value
    
  }

  getHeaderAttachmentCount(): any{
      
      return this.uploadedAdditionalAttachmentsArray.length;

  }

  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {

      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray =
      this.paymentFormGroup.get('attachments')?.value || [];
      
      
        if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!')
            }

            let uploadedAttachment:any = {
              dataUrl:'',
              name:file.name,
              file:file
              
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true)
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            })

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      this.paymentFormGroup.get('attachments')?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();

    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }


  openFileSelector(){

  }

  async submit(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true
      
    }

  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }


  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }


  // Optional: You can implement logic to show more info when the info icon is clicked.
  showInfo(): void {
    // Logic to show additional info (e.g., a dialog, alert, or modal)
    console.log("Info icon clicked - show additional info!");
  }

  // getPartNumberControl(index: number): FormControl {
  //   const rows = this.lineItemtableForm.get('rows') as FormArray;
  //   const row = rows.at(index) as FormGroup;
  //   // Ensure that the control handles both numbers and strings
  //   return row?.get('addedLineItempartNumber') as FormControl ?? new FormControl('');
  // }



//  async generateAndSendPdf(): Promise<void> {
//        if (!this.contentToPrint?.nativeElement) {
//          console.error('PDF content element not found!');
//          return;
//        }
     
//        // Expand all forms
//        this.isForm1Expand = true;
//        this.isForm2Expand = true;
//        this.isForm3Expand = true;
//        this.isForm4Expand = true;
//        this.isForm5Expand = true;
//        this.isForm6Expand = true;
//        this.isForm7Expand = true;
//        this.isForm8Expand = true;
//        this.isForm9Expand = true;
//        this.isForm10Expand = true;
//        this.isForm11Expand = true;
//        this.isForm12Expand = true;
//        this.isWrapDescription = true;
     
 
//        const element = this.contentToPrint.nativeElement;
//        const pdf = new jsPDF('p', 'mm', 'a4');
//        const pageWidth = pdf.internal.pageSize.getWidth() - 20; // with margins
//        const pageHeight = pdf.internal.pageSize.getHeight() - 20;
       
 
//        // Store original styles
//        const originalOverflow = element.style.overflow;
//        const originalHeight = element.style.height;
       
//        try {
//          // Temporarily modify styles for proper capture
//          element.style.overflow = 'visible';
//          element.style.height = 'auto';
         
//          // Wait for UI to update after expanding forms
//          await new Promise(resolve => setTimeout(resolve, 500));
     
//          // Get full content dimensions
//          const fullHeight = element.scrollHeight;
         
//          // Create options for html2canvas
//          const options = {
//            scale: 1,
//            useCORS: true,
//            allowTaint: true,
//            scrollX: 0,
//            scrollY: 0,
//            width: element.scrollWidth,
//            height: fullHeight,
//            windowWidth: element.scrollWidth,
//            windowHeight: fullHeight,
//            logging: true
//          };
     
//          // Capture entire content
//          const canvas = await html2canvas(element, options);
 
//          const imgWidth = pageWidth;
//          const imgHeight = (canvas.height * imgWidth) / canvas.width;
         
//          // Split across pages if content is taller than one page
//          let position = 0;
         
//          while (position < imgHeight) {
//            const sectionHeight = Math.min(pageHeight, imgHeight - position);
           
//            if (position > 0) {
//              pdf.addPage();
//            }
           
//            // Create a new canvas for each page section
//            const tempCanvas = document.createElement('canvas');
//            tempCanvas.width = canvas.width;
//            tempCanvas.height = sectionHeight * (canvas.height / imgHeight);
//            const ctx = tempCanvas.getContext('2d');
           
//            if (ctx) {
//              ctx.drawImage(
//                canvas,
//                0, // source x
//                position * (canvas.height / imgHeight), // source y
//                canvas.width, // source width
//                sectionHeight * (canvas.height / imgHeight), // source height
//                0, // destination x
//                0, // destination y
//                canvas.width, // destination width
//                sectionHeight * (canvas.height / imgHeight) // destination height
//              );
             
//              const imgData = tempCanvas.toDataURL('image/jpeg');
//              pdf.addImage(
//                imgData,
//                'JPEG',
//                10, // x
//                10, // y
//                imgWidth,
//                sectionHeight
//              );
//            }
           
//            position += sectionHeight;
//          }
         
//          const pdfBlob = pdf.output('blob');
        
//          // code to compress the pdf
//        //  const arrayBuffer =  await pdfBlob.arrayBuffer();
//        //  const buffer = Array.from(new Uint8Array(arrayBuffer));
//        //  console.log(arrayBuffer,'arraynuffer',buffer)
 
//        //   let formData = {
//        //     bufferFile: buffer,
//        //     rfqRefNumber: this.firstFormGroup.get('rfqRefNo')?.value,
//        //     rfqId: Number(this.rfqId)
//        //   }
 
//        //   console.log(formData,'formData')
 
//        //   await this.RfqGenerateFormService.uploadRfqAttachment(formData)
//          // Convert canvas to blob
//          // const blob = await new Promise<Blob>(resolve => {
//          //   canvas.toBlob(blob => {
//          //     if (blob) {
//          //       resolve(blob);
//          //     } else {
//          //       throw new Error('Canvas to Blob conversion failed');
//          //     }
//          //   }, 'application/pdf');
//          // });
 
 
        
//      let s3Location = `po/${this.firstFormGroup.get('purchaseOrderRefNumber')?.value}.pdf`
 
     
//      let _s3Params = {
//        fileKey: s3Location,
//        fileContentType: pdfBlob.type || 'application/pdf',
//      };
 
//      await this.awsSdkService
//        .getSignedUrlPromise(_s3Params)
//        .then((_fileUploadLink: any) => {
//          if (_fileUploadLink) {
//            this.webApiService
//              .putRequestExternalApi(_fileUploadLink, pdfBlob)
//              .then(async (_fileUploadData: any) => {
//                // //!Logic for saving file url in the database
//                let filePath =
//                  this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);
 
//                  let formdata = {
//                    filePath: this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink),
//                    rfqId:Number(this.rfqId)
//                  }
                 
//                 //   await this.RfqGenerateFormService.sendRfq(formdata)
 
 
//                 //  await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata)
 
//              })
//              .catch((_httpErrorResponse: HttpErrorResponse) => {
//                console.log(
//                  'Error while uploading file==>',
//                  _httpErrorResponse
//                );
//                this.fullLoaderService.hideLoader();
//                // Should use ngZone.run() if we are calling the snack bar in async callbacks
//                // this.ngZone.run(() => {
//                //   this.snack.open(
//                //     `${_httpErrorResponse.error.errors[0].message}`,
//                //     'OK',
//                //     {
//                //       duration: 3000,
//                //     }
//                //   );
//                // });
//              });
//          }
//        })
//        .catch((_httpErrorResponse: HttpErrorResponse) => {
//          console.log(
//            'Error while generating presigned url for file==>',
//            _httpErrorResponse
//          );
//          this.fullLoaderService.hideLoader();
//          // Should use ngZone.run() if we are calling the snack bar in async callbacks
//          // this.ngZone.run(() => {
//          //   this.snack.open(
//          //     `${_httpErrorResponse.error.errors[0].message}`,
//          //     'OK',
//          //     {
//          //       duration: 3000,
//          //     }
//          //   );
//          // });
//        });
 
         
//        } catch (error) {
//          console.error('Error generating or sending PDF:', error);
//          throw error; // Re-throw if you want calling code to handle it
//        } finally {
//          // Restore original styles
//          element.style.overflow = originalOverflow;
//        element.style.height = originalHeight;
//      }
//    }


  // downloadPO(){
  //    // Ensure all sections are expanded so the full document is captured
  //   this.isForm1Expand = true;
  //   this.isForm2Expand = true;
  //   this.isForm3Expand = true;
  //   this.isForm4Expand = true;
  //   this.isForm5Expand = true;
  //   this.isForm6Expand = true;
  //   this.isForm7Expand = true;
  //   this.isForm8Expand = true;
  //   this.isForm9Expand = true;
  //   this.isForm10Expand = true;
  //   this.isForm11Expand = true;
  //   this.isWrapDescription = true;
  //   setTimeout(()=>{
  //     this.generatePOPdf();
  //   },1000);
  // }

  

  async downloadPO(){
    this.fullLoaderService.showLoader()
    
    let fileName = 'PO-'+ this.firstFormGroup.get('purchaseOrderRefNumber')?.value +'.pdf';
    
    // let data = {
    //   supplierId: Number(this.cookieService.get("userId")),
    //   rfqId: this.rfqId
    // }
   // const poPayload = this.buildPurchaseOrderPayloadForSupplierAttachment();
   const newPayload=this.buildPurchaseOrderPayload();
    console.log({newPayload});

    const pdf = await this.purchaseOrderService.generateSupplierPoAttachment(newPayload)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
  }



  async acceptPO(){
    this.fullLoaderService.showLoader();
    await this.getLastAcceptedOrderId();
    this.fullLoaderService.hideLoader();
    this.showAcceptOrder = true;
  }

  async rejectPO(){
    this.fullLoaderService.showLoader();
    await this.fetchAllRejectionReason();
    this.fullLoaderService.hideLoader();
    this.showRejectOrder = true;
  }

  private buildPurchaseOrderPayloadForSupplierAttachment(poPdfPath?: string): any {
    const header = this.firstFormGroup?.value || {};
    const payment = this.paymentFormGroup?.value || {};
    const pricing = this.secondFormGroup?.value || {};

    const lineItemsFormArray = (this.lineItemtableForm?.get('rows') as FormArray) || this._formBuilder.array([]);
    const lineItems = lineItemsFormArray.controls.map((ctrl: any) => ctrl.value).map((li: any, idx: number) => ({
      position: li.position ?? idx + 1,
      id: li.id ?? null,
      partNumber: li.partNumber ?? null,
      supplierPartNumber: li.supplierPartNumber ?? null,
      itemDescription: li.itemDescription ?? null,
      impaId: li.impaId ?? null,
      buyerComment: li.buyerComment ?? null,
      supplierComment: li.supplierComment ?? null,
      customsCode: li.customsCode ?? null,
      uom: li.uom ?? null,
      supplierUom: li.supplierUom ?? null,
      requestedQuantity: li.quantity ?? 0,
      supplierQuantity: li.supplierQuantity ?? 0,
      unitCost: li.unitCost ?? 0,
      requestedUnitCost: li.requestedUnitCost ?? li.unitCost ?? 0,
      discount: li.discount ?? 0,
      discountedUnitPrice: li.discountedUnitPrice ?? 0,
      totalCost: li.totalCost ?? 0,
      requestedTotalCost: li.requestedTotalCost ?? li.totalCost ?? 0,
      leadTime: li.leadTime ?? 0,
      isActive: li.isActive ?? 1,
      declineReasonTypeId: li.declineReasonTypeId ?? null,
      declineReasonDescription: li.declineReasonDescription ?? null,
      declineOtherReason: li.delineOtherReason ?? null,
      isNew: li.isNew ?? 0,
      isAddedBySupplier: li.isAddedBySupplier ?? 0,
      supplierProductId: li.supplierProductId ?? 0,
      attachments: (li.attachments || []).map((a: any) => ({
        name: a.name ?? null,
        systemName: a.systemName ?? null,
        fileKey: a.fileKey ?? null,
        s3_path: a.s3_path ?? null,
      })),
    }));

    const termsAttachments = (this.uploadedAdditionalAttachmentsArray || []).map((f: any) => ({
      name: f.name ?? null,
      size: f.file?.size ?? null,
      mimeType: f.file?.type ?? null,
    }));

    const poDetails = {
      purchaseOrderRefNumber: header.purchaseOrderRefNumber || null,
      purchaseOrderDate: header.purchaseOrderDate || null,
      rfqRefNumber: header.rfqRefNumber || null,
      rfqDate: header.rfqDate || null,
      quoteRefNumber: header.quoteRefNumber || null,
      quotationDate: header.quotationDate || null,
      expectedDeliveryDate: header.expectedDeliveryDate || null,
    };

    const buyer = {
      company: {
        name: header.buyerName || null,
        email: header.buyerEmail || null,
        phone: header.buyerPhone || null,
        fax: header.buyerFax || null,
        address: header.buyerAddress || null,
        buyerOrganizationLogo: header.buyerOrganizationLogo || null,
      },
      contact: {
        person: header.buyerContactPerson || null,
        email: header.buyerContactEmail || null,
        phone: header.buyerContactPhone || null,
        fax: header.buyerContactFax || null,
        address: header.buyerContactAddress || null,
      }
    };

    const supplier = {
      id: Number(this.cookieService.get('userId')) || null,
      contactName: header.supplierContactName || null,
      email: header.supplierEmail || null,
      phone: header.supplierPhone || null,
      fax: header.supplierFax || null,
      companyEmail: header.supplierCompanyEmail || null,
      supplierOrganizationLogo: header.supplierOrganizationLogo || null,
    };

    const vessel = {
      name: header.vesselName || null,
      imoNumber: header.vesselIMONumber || null,
      type: header.vesselType || null,
      class: header.vesselClass || null,
    };

    const port = {
      name: header.portName || null,
      code: header.portCode || null,
      eta: header.vesselETA || null,
      etd: header.vesselETD || null,
    };

    const portAgent = {
      portAgencyName: payment.portAgencyName || null,
      name: payment.portAgentName || null,
      phoneNumber: payment.portAgentPhoneNumber || null,
      contact: payment.portAgentContact || null,
      phoneFax: payment.portAgentPhoneFax || null,
      email: payment.portAgentEmail || null,
      address: payment.portAgentAddress || null,
    };

    const freightForwarder = {
      companyName: payment.freightCompanyName || null,
      pic: payment.freightPIC || null,
      jobTitle: payment.freightJobTitle || null,
      email: payment.freightEmail || null,
      phone: payment.freightPhone || null,
      fax: payment.freightFax || null,
      address: payment.freightAddress || null,
      packaging: payment.freightPackaging || null,
      transportMode: payment.freightTransportMode || null,
    };

    const incotermDetails = {
      incoterms: header.incoterms || '',
      incotermLocations: header.incotermLocations || '',
    };

    const priceDetails = {
      currency: pricing.supplierCurrency || null,
      listPriceSubtotal: pricing.quoteLineItemListPriceSubtotal ?? 0,
      discount: pricing.quoteLineItemDiscount ?? 0,
      subtotal: pricing.quoteLineItemSubtotal ?? 0,
      generalDiscount: {
        type: pricing.quoteLineItemGeneralDiscountType || 'percentage',
        value: pricing.quoteLineItemGeneralDiscountValue ?? 0,
      },
      freight: (pricing.quoteLineItemFreight || []).map((f: any) => ({
        id: f.id ?? null,
        description: f.freightDescription ?? null,
        type: f.freightType ?? 'amount',
        value: Number(f.freightValue ?? 0),
        isActive: f.isActive ?? 1,
      })),
      freightTotal: pricing.quoteLineItemFreightTotal ?? 0,
      applicableTaxProfile: pricing.quoteLineItemApplicableTaxProfile ?? null,
      taxAmount: pricing.quoteLineItemTaxAmount ?? 0,
      total: pricing.quoteLineItemTotal ?? 0,
    };

    const termsAndConditions = {
      billingAddress: payment.billingAddress || null,
      applicableTaxProfile: payment.applicableTaxProfile || null,
      buyersPaymentTerms: payment.buyersPaymentTerms || null,
      text: payment.termsAndConditions || null,
      attachments: termsAttachments,
    };

    const taxDetails = {
      vat: this.headerResponse.taxNumber || null,
    };
    return {
      ids: {
        purchaseOrderId: this.purchaseOrderId ?? null,
        rfqId: this.rfqId ?? null,
        quoteId: this.quoteId ?? null,
      },
      purchaseOrder: poDetails,
      buyer,
      supplier,
      vessel,
      port,
      portAgent,
      freightForwarder,
      incotermDetails,
      priceDetails,
      termsAndConditions,
      lineItems,
      taxDetails,
      documents: {
        poPdfPath: poPdfPath || null,
      },
    };
  }


  private buildPurchaseOrderPayload(poPdfPath?: string): any {
    const header = this.firstFormGroup?.value || {};
    const payment = this.paymentFormGroup?.value || {};
    const pricing = this.secondFormGroup?.value || {};

    console.log("headerResponse",this.headerResponse);

    console.log("payment",payment);

    const lineItemsFormArray =
      (this.lineItemtableForm?.get('rows') as FormArray) ||
      this._formBuilder.array([]);
    const lineItems = lineItemsFormArray.controls
      .map((ctrl: any) => ctrl.value)
      .map((li: any, idx: number) => ({
        position: li.position ?? idx + 1,
        id: li.id ?? null,
        partNumber: li.partNumber ?? null,
        supplierPartNumber: li.supplierPartNumber ?? null,
        itemDescription: li.itemDescription ?? null,
        impaId: li.impaId ?? null,
        buyerComment: li.buyerComment ?? null,
        supplierComment: li.supplierComment ?? null,
        customsCode: li.customsCode ?? null,
        uom: li.uom ?? null,
        supplierUom: li.supplierUom ?? null,
        requestedQuantity: li.quantity ?? 0,
        supplierQuantity: li.supplierQuantity ?? 0,
        unitCost: li.unitCost ?? 0,
        requestedUnitCost: li.requestedUnitCost ?? li.unitCost ?? 0,
        discount: li.discount ?? 0,
        discountedUnitPrice: li.discountedUnitPrice ?? 0,
        totalCost: li.totalCost ?? 0,
        requestedTotalCost: li.requestedTotalCost ?? li.totalCost ?? 0,
        leadTime: li.leadTime ?? 0,
        isActive: li.isActive ?? 1,
        declineReasonTypeId: li.declineReasonTypeId ?? null,
        declineReasonDescription: li.declineReasonDescription ?? null,
        declineOtherReason: li.delineOtherReason ?? null,
        isNew: li.isNew ?? 0,
        isAddedBySupplier: li.isAddedBySupplier ?? 0,
        supplierProductId: li.supplierProductId ?? 0,
        attachments: (li.attachments || []).map((a: any) => ({
          name: a.name ?? null,
          systemName: a.systemName ?? null,
          fileKey: a.fileKey ?? null,
          s3_path: a.s3_path ?? null,
        })),
      }));

    const termsAttachments = (
      this.uploadedAdditionalAttachmentsArray || []
    ).map((f: any) => ({
      name: f.name ?? null,
      size: f.file?.size ?? null,
      mimeType: f.file?.type ?? null,
    }));

    const poDetails = {
      purchaseOrderRefNumber: header.purchaseOrderRefNumber || null,
      purchaseOrderDate: header.purchaseOrderDate || null,
      rfqRefNumber: header.rfqRefNumber || null,
      rfqDate: header.rfqDate || null,
      quoteRefNumber: header.quoteRefNumber || null,
      quotationDate: header.quotationDate || null,
      expectedDeliveryDate: header.expectedDeliveryDate || null,
    };

    const buyer = {
      company: {
        name: header.buyerName || null,
        email: header.buyerEmail || null,
        phone: header.buyerPhone || null,
        fax: header.buyerFax || null,
        address: header.buyerAddress || null,
        logo: this.buyerLogo || null,
      },
      contact: {
        person: header.buyerContactPerson || null,
        email: header.buyerContactEmail || null,
        phone: header.buyerContactPhone || null,
        fax: header.buyerContactFax || null,
        address: header.buyerContactAddress || null,
      },
    };
    const supplierDetails = {
      company: {
        name: this.headerResponse.supplierCompanyName || null,
        email: this.headerResponse.supplierCompanyEmail || null,
        phone: this.headerResponse.supplierPhone || null,
        fax: this.headerResponse.supplierFax || null,
        address: this.headerResponse.supplierAddress || null,
        logo: this.supplierLogo || null,
      },
      contact: {
        id: Number(this.supplierId) || null,
        contactName: header.supplierContactName || null,
        email: header.supplierEmail || null,
        phone: header.supplierPhone || null,
        fax: header.supplierFax || null,
      },
    };

    // const supplier = {
    //   id: Number(this.supplierId) || null,
    //   contactName: header.supplierContactName || null,
    //   email: header.supplierEmail || null,
    //   phone: header.supplierPhone || null,
    //   fax: header.supplierFax || null,
    //   companyEmail: header.supplierCompanyEmail || null,
    //   logo: this.supplierLogo || null,
    // };

    const vessel = {
      name: header.vesselName || null,
      imoNumber: header.vesselIMONumber || null,
      type: header.vesselType || null,
      class: header.vesselClass || null,
    };

    const port = {
      name: this.headerResponse.portName || null,
      code: this.headerResponse.portCode || null,
      eta: this.headerResponse.vesselEta || null,
      etd: this.headerResponse.vesselEtd || null,
    };

    const portAgent = {
      portAgencyName: this.portAgencyAndFreightAndBillingResponse.portAgencyName || null,
      name: this.portAgencyAndFreightAndBillingResponse.portAgentName || null,
      phoneNumber: this.portAgencyAndFreightAndBillingResponse.portAgentPhoneNumber || null,
      contact: this.portAgencyAndFreightAndBillingResponse.portAgentContact || null,
      phoneFax: this.portAgencyAndFreightAndBillingResponse.portAgentPhoneFax || null,
      email: this.portAgencyAndFreightAndBillingResponse.emailId || null,
      address: this.portAgencyAndFreightAndBillingResponse.address || null,
    };

    const freightForwarder = {
      companyName: this.portAgencyAndFreightAndBillingResponse.freightCompanyName || null,
      pic: this.portAgencyAndFreightAndBillingResponse.freightPIC || null,
      jobTitle: this.portAgencyAndFreightAndBillingResponse.freightJobTitle || null,
      email: this.portAgencyAndFreightAndBillingResponse.freightEmail || null,
      phone: this.portAgencyAndFreightAndBillingResponse.freightPhone || null,
      fax: this.portAgencyAndFreightAndBillingResponse.freightFax || null,
      address: this.portAgencyAndFreightAndBillingResponse.freightAddress || null,
      packaging: this.portAgencyAndFreightAndBillingResponse.freightPackaging || null,
      transportMode: this.portAgencyAndFreightAndBillingResponse.freightTransportMode || null,
    };

    const incotermDetails = {
      incotermId: null,
      incotermCode: this.incotermsCode || null,
      locations: this.incotermLocations || '',
    };

    const priceDetails = {
      currency: pricing.supplierCurrency || null,
      listPriceSubtotal: pricing.quoteLineItemListPriceSubtotal ?? 0,
      discount: pricing.quoteLineItemDiscount ?? 0,
      subtotal: pricing.quoteLineItemSubtotal ?? 0,
      generalDiscount: {
        type: pricing.quoteLineItemGeneralDiscountType || 'percentage',
        value: pricing.quoteLineItemGeneralDiscountValue ?? 0,
      },
      freight: (pricing.quoteLineItemFreight || []).map((f: any) => ({
        id: f.id ?? null,
        description: f.freightDescription ?? null,
        type: f.freightType ?? 'amount',
        value: Number(f.freightValue ?? 0),
        isActive: f.isActive ?? 1,
      })),
      freightTotal: pricing.quoteLineItemFreightTotal ?? 0,
      applicableTaxProfile: pricing.quoteLineItemApplicableTaxProfile ?? null,
      taxAmount: pricing.quoteLineItemTaxAmount ?? 0,
      total: pricing.quoteLineItemTotal ?? 0,
    };

    const taxDetails = {
      vat: this.headerResponse.taxNumber || null,
    };

    const termsAndConditions = {
      billingAddress: this.portAgencyAndFreightAndBillingResponse.billingAddress || null,
      applicableTaxProfile: this.portAgencyAndFreightAndBillingResponse.applicableTaxProfile || null,
      buyersPaymentTerms: this.portAgencyAndFreightAndBillingResponse.buyersPaymentTerms || null,
      text: payment.termsAndConditions || null,
      attachments: termsAttachments,
    };

    return {
      ids: {
        purchaseOrderId: this.purchaseOrderId ?? null,
        rfqId: this.rfqId ?? null,
        quoteId: this.quoteId ?? null,
      },
      purchaseOrder: poDetails,
      buyer,
      // supplier,
      supplierDetails,
      vessel,
      port,
      portAgent,
      freightForwarder,
      incotermDetails,
      priceDetails,
      termsAndConditions,
      lineItems,
      taxDetails,
      documents: {
        poPdfPath: poPdfPath || null,
      },
    };
  }

}
